module.exports = __webpack_public_path__ + "img/_11.5bca21ce.png";